import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Browse Categories
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Explore Sugargoo Spreadsheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Browse through our carefully organized product categories. Each spreadsheet is packed with trending finds, detailed product information, and direct shopping links.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-100 hover:bg-accent-50 border border-background-200/70 hover:border-accent-200 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} - Sugargoo Spreadsheet category`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 left-2 right-2">
                  <span className="block text-xs font-semibold text-background-50 text-center leading-tight drop-shadow-sm">
                    {cat.name}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            View All Products on Main Site
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}